<template>
  <section class="d-content-template-preview d-button-preview z-draggable-preview">
    <el-form-item
      :label="option.label"
      :prop="option.name"
      :rules="getRules"
      class="sm-height-button"
    >
      <el-button type="primary" size="small" @click="handleClick">{{option.btnText}}</el-button>
      <div class="z-tip-form-item" v-if="option.tip">{{option.tip}}</div>
    </el-form-item>
    <table-dialog
      ref="content"
      v-bind="tablelist"
      @handleConfirm="handleConfirm"
    >
      <template #tplPc="scope">
        <el-select v-model="scope.scope.row.tplPc" size="small" placeholder="请选择"
          :clearable="true"
          popper-class="jee-border"
          :popperAppendToBody='false'
        >
          <el-option
            v-for="item in scope.scope.row.pcTplPaths"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </template>
      <template #tplMobile="scope">
        <el-select v-model="scope.scope.row.tplMobile"
          popper-class="jee-border"
          :clearable="true"
          size="small" placeholder="请选择">
          <el-option
            v-for="item in scope.scope.row.mobileTplPaths"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </template>
    </table-dialog>
  </section>
</template>

<script>
import previewMixin from '@/components/draggable/Mixin/previewMixin'
import tableDialog from '@/components/mixins/tableDialog'

export default {
  name: 'DContentTemplatePreview',
  mixins: [previewMixin, tableDialog],
  data () {
    return {
      tablelist: {
        width: '714px',
        showSelection: false,
        showPagination: false,
        showSearchHeader: false,
        rowKey: 'modelId',
        data: [],
        columns: [
          {
            label: '内容模型',
            prop: 'modelName',
            width: '150px'
          },
          {
            scopeType: 'slot',
            label: '内容PC端模板',
            prop: 'tplPc'
          },
          {
            scopeType: 'slot',
            label: '内容手机端模板',
            prop: 'tplMobile'
          }
        ]
      }
    }
  },
  methods: {
    handleClick () {
      this.$refs.content.showDialog()
      this.fetchChannelContentModel()
    },
    // 设置内容模型表格
    fetchChannelContentModel () {
      this.tablelist.loading = true
      const params = {
        channelId: this.form.id
      }
      this.$request.fetchChannelContentModel(params).then(res => {
        if (res.code === 200) {
          this.tablelist.data = res.data.map(d => {
            if (this.value instanceof Array && this.value.length) {
              const model = this.value.find(v => v.modelId === d.modelId)
              if (model) {
                d.tplMobile = model.tplMobile || d.tplMobile
                d.tplPc = model.tplPc || d.tplPc
              }
            }
            return d
          })
        }
        this.tablelist.loading = false
      }).catch(() => {
        this.tablelist.loading = false
      })
    },
    handleConfirm () {
      const data = this.tablelist.data.map(d => {
        return {
          tplMobile: d.tplMobile,
          tplPc: d.tplPc,
          modelId: d.modelId
        }
      })
      this.$emit('input', data)
      this.$refs.content.handleCancel()
    }
  }
}
</script>

<style lang="scss">
.d-content-template-preview {
  .el-dialog{
    .el-table{
      .el-table__body{
        td{
          border-bottom: 0;
        }
      }
    }
  }
}
</style>
